export const SECOND = 1000;
export const MINUTE = 60 * SECOND;
export const HOUR = 60 * MINUTE;
export const DAY = 24 * HOUR;
export const WEEK = DAY * 7;
export const MONTH = DAY * 30;
export const THREE_MONTHS = MONTH * 3;
export const SIX_MONTHS = MONTH * 6;
export const YEAR = DAY * 365;
export const DEFAULT_DATE_FORMAT = 'yyyy-MM-dd'
export const DEFAULT_DATETIME_FORMAT = 'yyyy-MM-dd HH:mm'
export const DEFAULT_DATETIME_FULL_FORMAT = 'yyyy-MM-dd HH:mm:ss'
export const FRIENDLY_DATETIME_FORMAT = 'MMM do yyyy HH:mm'
export const FRIENDLY_DATE_FORMAT = 'MMM do yyyy'

export const dateRanges = {
  WEEK: 'week',
  MONTH: 'month',
  THREE_MONTHS: 'three-months',
  SIX_MONTHS: 'six-months',
  YEAR: 'year',
};
export const dateRangeMappings = {
  [dateRanges.WEEK]: WEEK,
  [dateRanges.MONTH]: MONTH,
  [dateRanges.THREE_MONTHS]: THREE_MONTHS,
  [dateRanges.SIX_MONTHS]: SIX_MONTHS,
  [dateRanges.YEAR]: YEAR,
}
/**
 * Returns a date range array given a date range type (WEEK/MONTH etc)
 * @param {string} dateRangeType to calculate the date range
 * @return {Date[]}
 */
export function getDateRange (dateRangeType) {
  let dateToSubtract = dateRangeMappings[dateRangeType] || DAY;
  const start = new Date()
  const end = new Date()
  start.setTime(start.getTime() - dateToSubtract)
  return [start, end]
}
